import axios from 'axios';
import {buildQuery} from 'utils/QueryUtils';

export const findDistricts = (headers, params) => {
  let query = buildQuery(params);
  return axios.get(
    `${process.env.REACT_APP_CATEGORY_API_URL}/districts${query}`,
    {
      headers,
    },
  );
};

export const findDistrictById = (headers, id) => {
  return axios.get(
    `${process.env.REACT_APP_CATEGORY_API_URL}/districts/${id}`,
    {
      headers,
    },
  );
};

export const createDistrict = (headers, data) => {
  return axios.post(
    `${process.env.REACT_APP_CATEGORY_API_URL}/districts`,
    data,
    {
      headers,
    },
  );
};

export const updateDistrict = (headers, id, data) => {
  return axios.patch(
    `${process.env.REACT_APP_CATEGORY_API_URL}/districts/${id}`,
    data,
    {
      headers,
    },
  );
};

export const deleteDistrict = (headers, id) => {
  return axios.delete(
    `${process.env.REACT_APP_CATEGORY_API_URL}/districts/${id}`,
    {
      headers: headers,
    },
  );
};

export const deleteDistricts = (headers, ids) => {
  return axios.delete(
    `${process.env.REACT_APP_CATEGORY_API_URL}/districts?id=${ids.join()}`,
    {
      headers: headers,
    },
  );
};
